function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
export var EventManager = /*#__PURE__*/function () {
  function EventManager() {
    _classCallCheck(this, EventManager);
    this._events = {};
  }
  return _createClass(EventManager, [{
    key: "addEventListener",
    value: function addEventListener(eventType, callback) {
      if (!this._events) {
        this._events = {};
      }
      if (!this._events[eventType]) {
        this._events[eventType] = [];
      }
      this._events[eventType].push(callback);
      return callback;
    }
  }, {
    key: "dispatch",
    value: function dispatch(eventType) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key2 = 1; _key2 < _len; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }
      if (eventType && this._events[eventType]) {
        this._events[eventType].forEach(function (listener) {
          try {
            listener.apply(void 0, args);
          } catch (e) {
            console.error('Some listener function on dispatch event has a problem', e);
          }
        });
      }
    }
  }, {
    key: "removeEventListener",
    value: function removeEventListener(eventTypeOrCallBack) {
      var _this = this;
      if (!this._events) {
        this._events = {};
      }
      if (typeof eventTypeOrCallBack === "string") {
        var eventType = eventTypeOrCallBack;
        var eventTarget = this._events[eventType];
        if (eventTarget) {
          this._events[eventType] = [];
        }
      } else if (typeof eventTypeOrCallBack === "function") {
        var targetEvent = eventTypeOrCallBack;
        var eventKeys = Object.keys(this._events);
        eventKeys.forEach(function (_key) {
          _this._events[_key] = _this._events[_key].filter(function (listener) {
            return listener !== targetEvent;
          });
        });
      }
    }
  }, {
    key: "removeEventListenerAll",
    value: function removeEventListenerAll() {
      this._events = {};
    }
  }]);
}();